import cx from 'classnames'
import styles from './DefineAreas.module.css'
import Icon from '../../../../components/Icon'
import {
    faChevronLeft,
    faChevronRight,
} from '@fortawesome/free-solid-svg-icons'
import React, { useEffect } from 'react'
import { StoredTemplate, Template } from '../../../../types/Individualization'
import { useTranslation } from 'react-i18next'

type SidebarProps = {
    templates: Template[] | StoredTemplate[]
    active: string | number | null
    changeTemplate: (id: string | number) => void
    show: boolean
    toggleSidebar: () => void
    colors: { background: string; text: string }
}

const Sidebar: React.FC<SidebarProps> = ({
    templates,
    active,
    changeTemplate,
    show,
    toggleSidebar,
    colors,
}) => {
    useEffect(() => {
        if (templates.length === 1 && !active) {
            changeTemplate(templates[0].id)
            toggleSidebar()
        }
    }, [templates, active, changeTemplate, toggleSidebar])

    const { t } = useTranslation(['individualization'])

    return (
        <>
            <div
                className={cx(styles['sidebar-wrapper'])}
                style={{
                    left: show ? '0px' : '-240px',
                    background: show ? '#20232a' : 'transparent',
                }}
            >
                <div className={cx(styles['template-list'])}>
                    {templates.map((template, index) => {
                        return (
                            <div
                                className={cx(styles['template-icon'])}
                                key={`template_${index}`}
                            >
                                <img
                                    className={cx(styles['template-img'])}
                                    style={{
                                        border:
                                            template.id === active
                                                ? '2px solid ' +
                                                  colors.background
                                                : 'none',
                                    }}
                                    src={template.src}
                                    alt={template.name}
                                    onClick={() => {
                                        changeTemplate(template.id)
                                        toggleSidebar()
                                    }}
                                    key={template.id}
                                />
                                <span className={cx(styles['template-name'])}>
                                    {template.name}
                                </span>
                            </div>
                        )
                    })}
                </div>
            </div>
            <div
                className={cx(styles['menu-icon'], 'zr-position-absolute')}
                onClick={toggleSidebar}
                style={{
                    left: show ? 'calc(240px + 1rem)' : '1rem',
                    background: colors.background,
                }}
            >
                <Icon
                    icon={show ? faChevronLeft : faChevronRight}
                    size={'lg'}
                    color={colors.text}
                />
            </div>
            <div
                className={cx(styles['template-box'])}
                style={{
                    left: show ? 'calc(240px + 1rem)' : '1rem',
                }}
            >
                {t('progress.upload_templates')}
            </div>
        </>
    )
}

export default Sidebar
